module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"defaultOperationalDepartment":"Operating","departments":"Default departments","defaultEconomicalDepartment":"Economical"},"no":{"defaultOperationalDepartment":"Operativ","departments":"Standard avdelinger","defaultEconomicalDepartment":"Økonomisk"}}')
  delete Component.options._Ctor
}
